import React, { FC } from 'react'

import { useAppSelector } from '../../store/hooks'

import { CustomLoaderOverlay } from './customLoaderOverlay'

export const LoaderOverlay: FC = () => {
  const { isLoading } = useAppSelector(({ loader }) => loader)

  return (
    <div id="loader-portal">
      <CustomLoaderOverlay open={isLoading} />
    </div>
  )
}
